import React from 'react';
import { array, func, number, bool, object } from 'prop-types';
import { H3 } from '@seekube-tech/ui-kit';
import { useFormatMessage } from 'react-intl-hooks';
import { getId } from '@/utils/global';
import { JobdatingCard } from './components/JobdatingCard';
import { NoJobdating } from './components';
import './styles.less';
import { getCTARole } from '@/utils/event';

const JobdatingsYours = ({ isFetching, events, goTo, total, authUser, downloadAllCV2, loadingDownload }) => {
  const t = useFormatMessage();

  return (
    <div>
      <H3 className="pageTitle">{t({ id: 'events.your.title' })}</H3>

      {isFetching ? (
        <>
          <JobdatingCard key={0} isSkeleton/>
          {authUser._currentOrganization ? (<JobdatingCard key={1} isSkeleton/>) : ''}
          {authUser.isAdmin ? (<JobdatingCard key={2} isSkeleton/>) : ''}
          {authUser.isAdmin ? (<JobdatingCard key={3} isSkeleton/>) : ''}
          {authUser.isAdmin ? (<JobdatingCard key={4} isSkeleton/>) : ''}
        </>) : (
        <>
          {total > 0 ? (events || []).map((event) => {
            const role = getCTARole(event);
            
            return (
              <JobdatingCard
                key={getId(event._id)}
                event={event}
                goTo={goTo}
                role={role}
                authUser={authUser}
                downloadAllCV2={() => downloadAllCV2(event)}
                loadingDownload={loadingDownload}
              />);
          }) : (
            <NoJobdating goTo={goTo}/>
          )}
        </>
      )}
    </div>
  )
}

JobdatingsYours.propTypes = {
  events: array,
  goTo: func,
  isFetching: bool,
  authUser: object,
  downloadAllCV2: func,
  loadingDownload: bool,
  total: number,
};

export default React.memo(JobdatingsYours);
